import template from './wizard_leave_setup_holidays.html';
import tr from '../../lib/default-translator.js';

class WizardLeaveSetupHolidays
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable(null); 
		this.holiday_types = ko.observableArray();
		this.holiday_rules = ko.observableArray();
		this.holiday_type = ko.observable();
		this.holiday_rule = ko.observable();
		this.priority = ko.observable(1); 
		this.leave_type_linked_holidays = ko.observableArray();
		this.ignore_weekend_holidays = ko.observable(false); 
	}

	close()
	{
		this.dialog.close();
	}

	async back_wizard()
	{
		if (this.leave_type_id())
		{
			this.dialog.close();
			//await Grape.dialog.open('WizardLeaveSetupOverview', {leave_type_id: this.leave_type_id()});
			//this.dialog.updateData();
			return;
		}

		this.dialog.close();
		Object.assign(this.dialog.bindings.leave_object, {leave_type_linked_holidays: this.leave_type_linked_holidays() })
		await Grape.dialog.open('WizardLeaveSetupRoles', this.dialog.bindings);
		this.dialog.updateData();
	};

	async edit_holidays()
	{
		let data = this.holiday_types().find(x => x.holiday_type === this.holiday_type())
		await Grape.dialog.open('WizardHolidaySetup', data);
		this.dialog.updateData();
	};

	async next_wizard()
	{
		Object.assign(this.dialog.bindings.leave_object, {leave_type_linked_holidays: this.leave_type_linked_holidays() })
		await Grape.dialog.open('WizardLeaveSetupRestrictions', this.dialog.bindings);
		this.dialog.updateData();
	};

	async add_new_holiday_type()
	{
		await Grape.dialog.open('AdminAddNewHolidayType', {wizard: true});
		await this.dialog.updateData();
		if (d && d.holiday_type)
			this.holiday_type(d.holiday_type);
	}

	link_holiday_type()
	{
		//validation: priority > 0 
		if (this.priority() <= 0  || this.priority() % 1 != 0)
		{
			Grape.alerts.alert({type: 'error', message: tr('The priority must be a positive integer value'), title: tr('Error')});
			return;
		}

		let holiday_type = {
			holiday_type: this.holiday_type(),
			priority: this.priority(),
			holiday_rule: this.holiday_rule()
		}
		this.leave_type_linked_holidays.push(holiday_type);
	}

	remove_linked_leave(v, e)
	{
		let linked_holidays = this.leave_type_linked_holidays();
		let filtered = _.remove(linked_holidays, (n) => {
			return n.holiday_type !== v.holiday_type;
		});
		this.leave_type_linked_holidays(filtered);
	}

	async back_and_save() 
	{
		//update fields
		this.dialog.bindings.leave_object.leave_type_linked_holidays = this.leave_type_linked_holidays();
		this.dialog.bindings.leave_object.ignore_weekend_holidays = this.ignore_weekend_holidays();
		//save new leave type
		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.dialog.bindings.leave_object);

		if (res.status === 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Changes has been saved'), title: tr('Success')});
			this.dialog.close();
			//await Grape.dialog.open('WizardLeaveSetupOverview', {leave_type_id: this.dialog.bindings.leave_object.leave_type_id});
			//this.dialog.updateData();
		}
	}
};

class WizardLeaveSetupHolidaysPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupHolidays(this);
	}

	init()
	{
		//apply bindings
		if (this.bindings.leave_object.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id);

		if (this.bindings.leave_object.leave_type_linked_holidays) 
			this.viewModel.leave_type_linked_holidays(this.bindings.leave_object.leave_type_linked_holidays);
		
		if (this.bindings.leave_object.ignore_weekend_holidays) 
			this.viewModel.ignore_weekend_holidays(this.bindings.leave_object.ignore_weekend_holidays)

		this.bindings.leave_object.ignore_weekend_holidays || this.viewModel.ignore_weekend_holidays(this.bindings.ignore_weekend_holidays);
		this.updateData();
	}

	async updateData()
	{
		let res_types = await Grape.fetches.getJSON('/api/record', {
			table: 'holiday_types',
			schema: 'public'
		});

		if (res_types.status !== 'ERROR')
		{
			if (res_types.records)
				this.viewModel.holiday_types(res_types.records);
		}

		let res_rules = await Grape.fetches.getJSON('/api/record', {
			table: 'holiday_rules',
			limit: 1000000
		});

		if (res_rules.status !== 'ERROR')
		{
			if (res_rules.records)
				this.viewModel.holiday_rules(res_rules.records);
		}
	};
};

export default {
	name: 'WizardLeaveSetupHolidays',
	dialog_class: WizardLeaveSetupHolidaysPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_holidays',
	provider: 'ps'
};
